// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
	width: 675px;
	border: 1px solid #d4d4d4;
	border-bottom: 4px solid #d4d4d4;
	position: relative;
	padding-top: 20px;
	padding-left: 18px;
	padding-right: 18px;
	background: #FFF;
}

.min-width-container {
	min-width: 675px;
}

.title {
	margin-bottom: 50px;
	font-family: MuseoSans-500;
	font-size: 18px;
	color: #404141;
}

.result-info {
	font-family: MuseoSans-300;
	font-size: 13px;
	color: #404141;
	margin-top: -15px;
}

.result-detail {
	margin-bottom: 40px;
}

.result-detail.no-bottom-margin {
	margin-bottom: 0px;
}

.result-detail p {
	margin-bottom: 0px;
	font-family: MuseoSans-100;
	font-size: 13px;
	color: #404141;
}

.result-detail p span {
	font-family: MuseoSans-300;
	font-size: 13px;
	color: #1C1D1D;
	line-height: 15px;
}

.result-detail p span.result-data-timeout {
	font-family: MuseoSans-100;
  font-size: 13px;
  color: #b3b3b3;
}

.result-detail p.data-timeout {
	margin-bottom: 6px;
}

.data-timeout img {
	width: 12px !important;
}

.data-timeout .btn-link {
	font-family: MuseoSans-500;
  font-size: 13px;
  color: #00a1e0;
  width: 50px;
  padding: 0px;
}

.result-detail .data-timeout span {
	vertical-align: middle;
	font-family: MuseoSans-500;
  font-size: 13px;
}

.warning {
	border: 2px solid rgb(248, 164, 167);
	margin-bottom: 12px;
}

.warning span.delete {
	float: right;
	line-height: 2px;
	margin-top: 8px;
}

.warning span.delete img {
	width: 14px;
	margin-right: 10px;
}

.warning span.delete > img + img,
span.delete:hover > img {
  display: none;
}

.warning span.delete:hover > img + img {
  display: inherit;
}

.warning .logo {
	float: left;
	margin-left: 40px;
	margin-top: 31px;
}

.warning img {
	width: 40px;
}

.warning .content {
	margin-left: 80px;
	margin-right: 50px;
	text-align: center;
}

.warning .title {
	margin-top: 15px;
	margin-bottom: 7px;
}

.warning .description {
	font-family: MuseoSans-300;
	font-size: 12px;
	letter-spacing: 0px;
	line-height: 1.25;
	margin-bottom: 4px;
}

.warning button {
	width: auto;
}

.warning button:nth-of-type(2) {
	margin-top: -15px;
}

.warning.gsm-warning .description {
	margin-bottom: 22px;
}

:host >>> .warning p.description span {
	font-family: MuseoSans-500;
	font-size: 12px;
	color: #1C1D1D;
}

:host >>> .warning a {
	font-family: MuseoSans-300;
	font-size: 12px;
	color: #00A1E0;
}

form {
	margin-top: 40px;
}

.sync {
	padding-top: 28px;
	padding-left: 3px;
	font-family: MuseoSans-300;
	font-size: 12px;
	color: #404141;
}

.sync img {
	margin-right: 5px;
}

.more-settings-description {
	font-family: MuseoSans-300;
	font-size: 12px;
	color: #404141;
	letter-spacing: 0.01px;
  text-align: center;
  line-height: 1.25;
}

.more-settings-description button {
	font-family: MuseoSans-300;
	font-size: 12px;
	letter-spacing: 0.01px;
	padding: 0px;
	width: auto;
	display: inline-block;
}

.status-message {
	text-align: center;
	font-family: MuseoSans-300;
	font-size: 13px;
	color: #404141;
}

.action {
	text-align: center;
	margin-top: 20px;
	margin-bottom: 80px;
}

button {
	width: 200px;
}

.container-success {
	background: #3FAC49;
	border: 1px solid #399041 !important;
	border-bottom: 4px solid #399041 !important;
	height: 249px;
}

.container-success .title {
	color: #FFFFFF !important;
}

.container-failed {
	border: 1px solid #ED1C24 !important;
	border-bottom: 4px solid #ED1C24 !important;
}

.success-message {
	font-family: MuseoSans-500;
	font-size: 13px;
	color: #FFFFFF;
	margin-top: -20px;
}

hr {
  margin: 30px -18px 30px;
}

.actions {
  position: relative;
  bottom: 20px;
  right: 10px;
  margin-top: 36px;
  margin-right: -10px;
}

.actions button {
  width: 100px;
}

.btn-primary {
  margin-left: 10px;
}

.btn-secondary:focus {
  color: #15325F;
}

.btn-link {
	font-family: MuseoSans-300;
	font-size: 12px;
	margin: 0px;
}

.btn.sync-button {
	padding: 4px 16px;
}

.btn.sync-button.smbc-sync {
	margin-top: 40px;
}

.sync-button span {
	vertical-align: middle;
}

.sync-button img {
	margin-left: 10px;
}

.footer_when_no_buttons {
	margin-bottom: 64px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/connect-state/connect-state.component.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,yBAAyB;CACzB,gCAAgC;CAChC,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,0BAA0B;EACzB,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;CACC,sBAAsB;CACtB,0BAA0B;EACzB,eAAe;AACjB;;AAEA;CACC,oCAAoC;CACpC,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,sBAAsB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,sBAAsB;CACtB,YAAY;CACZ,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,0BAA0B;CAC1B,eAAe;CACf,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,oCAAoC;CACpC,2CAA2C;CAC3C,aAAa;AACd;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,oCAAoC;CACpC,2CAA2C;AAC5C;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,cAAc;CACd,iBAAiB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB","sourcesContent":[".container {\n\twidth: 675px;\n\tborder: 1px solid #d4d4d4;\n\tborder-bottom: 4px solid #d4d4d4;\n\tposition: relative;\n\tpadding-top: 20px;\n\tpadding-left: 18px;\n\tpadding-right: 18px;\n\tbackground: #FFF;\n}\n\n.min-width-container {\n\tmin-width: 675px;\n}\n\n.title {\n\tmargin-bottom: 50px;\n\tfont-family: MuseoSans-500;\n\tfont-size: 18px;\n\tcolor: #404141;\n}\n\n.result-info {\n\tfont-family: MuseoSans-300;\n\tfont-size: 13px;\n\tcolor: #404141;\n\tmargin-top: -15px;\n}\n\n.result-detail {\n\tmargin-bottom: 40px;\n}\n\n.result-detail.no-bottom-margin {\n\tmargin-bottom: 0px;\n}\n\n.result-detail p {\n\tmargin-bottom: 0px;\n\tfont-family: MuseoSans-100;\n\tfont-size: 13px;\n\tcolor: #404141;\n}\n\n.result-detail p span {\n\tfont-family: MuseoSans-300;\n\tfont-size: 13px;\n\tcolor: #1C1D1D;\n\tline-height: 15px;\n}\n\n.result-detail p span.result-data-timeout {\n\tfont-family: MuseoSans-100;\n  font-size: 13px;\n  color: #b3b3b3;\n}\n\n.result-detail p.data-timeout {\n\tmargin-bottom: 6px;\n}\n\n.data-timeout img {\n\twidth: 12px !important;\n}\n\n.data-timeout .btn-link {\n\tfont-family: MuseoSans-500;\n  font-size: 13px;\n  color: #00a1e0;\n  width: 50px;\n  padding: 0px;\n}\n\n.result-detail .data-timeout span {\n\tvertical-align: middle;\n\tfont-family: MuseoSans-500;\n  font-size: 13px;\n}\n\n.warning {\n\tborder: 2px solid rgb(248, 164, 167);\n\tmargin-bottom: 12px;\n}\n\n.warning span.delete {\n\tfloat: right;\n\tline-height: 2px;\n\tmargin-top: 8px;\n}\n\n.warning span.delete img {\n\twidth: 14px;\n\tmargin-right: 10px;\n}\n\n.warning span.delete > img + img,\nspan.delete:hover > img {\n  display: none;\n}\n\n.warning span.delete:hover > img + img {\n  display: inherit;\n}\n\n.warning .logo {\n\tfloat: left;\n\tmargin-left: 40px;\n\tmargin-top: 31px;\n}\n\n.warning img {\n\twidth: 40px;\n}\n\n.warning .content {\n\tmargin-left: 80px;\n\tmargin-right: 50px;\n\ttext-align: center;\n}\n\n.warning .title {\n\tmargin-top: 15px;\n\tmargin-bottom: 7px;\n}\n\n.warning .description {\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tletter-spacing: 0px;\n\tline-height: 1.25;\n\tmargin-bottom: 4px;\n}\n\n.warning button {\n\twidth: auto;\n}\n\n.warning button:nth-of-type(2) {\n\tmargin-top: -15px;\n}\n\n.warning.gsm-warning .description {\n\tmargin-bottom: 22px;\n}\n\n:host >>> .warning p.description span {\n\tfont-family: MuseoSans-500;\n\tfont-size: 12px;\n\tcolor: #1C1D1D;\n}\n\n:host >>> .warning a {\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor: #00A1E0;\n}\n\nform {\n\tmargin-top: 40px;\n}\n\n.sync {\n\tpadding-top: 28px;\n\tpadding-left: 3px;\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor: #404141;\n}\n\n.sync img {\n\tmargin-right: 5px;\n}\n\n.more-settings-description {\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tcolor: #404141;\n\tletter-spacing: 0.01px;\n  text-align: center;\n  line-height: 1.25;\n}\n\n.more-settings-description button {\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tletter-spacing: 0.01px;\n\tpadding: 0px;\n\twidth: auto;\n\tdisplay: inline-block;\n}\n\n.status-message {\n\ttext-align: center;\n\tfont-family: MuseoSans-300;\n\tfont-size: 13px;\n\tcolor: #404141;\n}\n\n.action {\n\ttext-align: center;\n\tmargin-top: 20px;\n\tmargin-bottom: 80px;\n}\n\nbutton {\n\twidth: 200px;\n}\n\n.container-success {\n\tbackground: #3FAC49;\n\tborder: 1px solid #399041 !important;\n\tborder-bottom: 4px solid #399041 !important;\n\theight: 249px;\n}\n\n.container-success .title {\n\tcolor: #FFFFFF !important;\n}\n\n.container-failed {\n\tborder: 1px solid #ED1C24 !important;\n\tborder-bottom: 4px solid #ED1C24 !important;\n}\n\n.success-message {\n\tfont-family: MuseoSans-500;\n\tfont-size: 13px;\n\tcolor: #FFFFFF;\n\tmargin-top: -20px;\n}\n\nhr {\n  margin: 30px -18px 30px;\n}\n\n.actions {\n  position: relative;\n  bottom: 20px;\n  right: 10px;\n  margin-top: 36px;\n  margin-right: -10px;\n}\n\n.actions button {\n  width: 100px;\n}\n\n.btn-primary {\n  margin-left: 10px;\n}\n\n.btn-secondary:focus {\n  color: #15325F;\n}\n\n.btn-link {\n\tfont-family: MuseoSans-300;\n\tfont-size: 12px;\n\tmargin: 0px;\n}\n\n.btn.sync-button {\n\tpadding: 4px 16px;\n}\n\n.btn.sync-button.smbc-sync {\n\tmargin-top: 40px;\n}\n\n.sync-button span {\n\tvertical-align: middle;\n}\n\n.sync-button img {\n\tmargin-left: 10px;\n}\n\n.footer_when_no_buttons {\n\tmargin-bottom: 64px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
